/**
 * CSS Constants
 */
/** @private */
export var ROOT = 'e-schedule';
/** @private */
export var RTL = 'e-rtl';
/** @private */
export var DEVICE_CLASS = 'e-device';
/** @private */
export var MULTI_DRAG = 'e-multi-drag';
/** @private */
export var ICON = 'e-icons';
/** @private */
export var ENABLE_CLASS = 'e-enable';
/** @private */
export var DISABLE_CLASS = 'e-disable';
/** @private */
export var TABLE_CONTAINER_CLASS = 'e-table-container';
/** @private */
export var SCHEDULE_TABLE_CLASS = 'e-schedule-table';
/** @private */
export var ALLDAY_CELLS_CLASS = 'e-all-day-cells';
/** @private */
export var HEADER_POPUP_CLASS = 'e-header-popup';
/** @private */
export var HEADER_CALENDAR_CLASS = 'e-header-calendar';
/** @private */
export var ALLDAY_ROW_CLASS = 'e-all-day-row';
/** @private */
export var CONTENT_TABLE_CLASS = 'e-content-table';
/** @private */
export var WORK_CELLS_CLASS = 'e-work-cells';
/** @private */
export var WORK_HOURS_CLASS = 'e-work-hours';
/** @private */
export var POPUP_OPEN = 'e-popup-open';
/** @private */
export var POPUP_CLOSE = 'e-popup-close';
/** @private */
export var DATE_HEADER_WRAP_CLASS = 'e-date-header-wrap';
/** @private */
export var DATE_HEADER_CONTAINER_CLASS = 'e-date-header-container';
/** @private */
export var HEADER_CELLS_CLASS = 'e-header-cells';
/** @private */
export var WORKDAY_CLASS = 'e-work-days';
/** @private */
export var OTHERMONTH_CLASS = 'e-other-month';
/** @private */
export var CURRENT_DAY_CLASS = 'e-current-day';
/** @private */
export var CURRENTDATE_CLASS = 'e-current-date';
/** @private */
export var CURRENT_PANEL_CLASS = 'e-current-panel';
/** @private */
export var PREVIOUS_PANEL_CLASS = 'e-previous-panel';
/** @private */
export var NEXT_PANEL_CLASS = 'e-next-panel';
/** @private */
export var PREVIOUS_DATE_CLASS = 'e-prev';
/** @private */
export var NEXT_DATE_CLASS = 'e-next';
/** @private */
export var TRANSLATE_CLASS = 'e-translate';
/** @private */
export var LEFT_INDENT_CLASS = 'e-left-indent';
/** @private */
export var LEFT_INDENT_WRAP_CLASS = 'e-left-indent-wrap';
/** @private */
export var EVENT_TABLE_CLASS = 'e-event-table';
/** @private */
export var RESOURCE_LEFT_TD_CLASS = 'e-resource-left-td';
/** @private */
export var RESOURCE_GROUP_CELLS_CLASS = 'e-resource-group-cells';
/** @private */
export var RESOURCE_TEXT_CLASS = 'e-resource-text';
/** @private */
export var RESOURCE_COLUMN_WRAP_CLASS = 'e-resource-column-wrap';
/** @private */
export var RESOURCE_COLUMN_TABLE_CLASS = 'e-resource-column-table';
/** @private */
export var RESOURCE_CHILD_CLASS = 'e-child-node';
/** @private */
export var RESOURCE_PARENT_CLASS = 'e-parent-node';
/** @private */
export var RESOURCE_EXPAND_CLASS = 'e-resource-expand';
/** @private */
export var RESOURCE_COLLAPSE_CLASS = 'e-resource-collapse';
/** @private */
export var RESOURCE_TREE_ICON_CLASS = 'e-resource-tree-icon';
/** @private */
export var RESOURCE_CELLS_CLASS = 'e-resource-cells';
/** @private */
export var TIME_CELLS_WRAP_CLASS = 'e-time-cells-wrap';
/** @private */
export var TIME_CELLS_CLASS = 'e-time-cells';
/** @private */
export var TIME_SLOT_CLASS = 'e-time-slots';
/** @private */
export var ALTERNATE_CELLS_CLASS = 'e-alternate-cells';
/** @private */
export var CURRENT_TIME_CLASS = 'e-current-time';
/** @private */
export var CURRENT_TIMELINE_CLASS = 'e-current-timeline';
/** @private */
export var PREVIOUS_TIMELINE_CLASS = 'e-previous-timeline';
/** @private */
export var HIDE_CHILDS_CLASS = 'e-hide-childs';
/** @private */
export var SCROLL_CONTAINER_CLASS = 'e-scroll-container';
/** @private */
export var WRAPPER_CLASS = 'e-wrapper';
/** @private */
export var TIMELINE_WRAPPER_CLASS = 'e-timeline-wrapper';
/** @private */
export var APPOINTMENT_WRAPPER_CLASS = 'e-appointment-wrapper';
/** @private */
export var DAY_WRAPPER_CLASS = 'e-day-wrapper';
/** @private */
export var TOOLBAR_CONTAINER = 'e-schedule-toolbar-container';
/** @private */
export var RESOURCE_TOOLBAR_CONTAINER = 'e-schedule-resource-toolbar-container';
/** @private */
export var HEADER_TOOLBAR = 'e-schedule-toolbar';
/** @private */
export var RESOURCE_HEADER_TOOLBAR = 'e-schedule-resource-toolbar';
/** @private */
export var SELECTED_CELL_CLASS = 'e-selected-cell';
/** @private */
export var WEEK_NUMBER_WRAPPER_CLASS = 'e-week-number-wrapper';
/** @private */
export var WEEK_NUMBER_CLASS = 'e-week-number';
/** @private */
export var APPOINTMENT_WRAP_CLASS = 'e-appointment-wrap';
/** @private */
export var WRAPPER_CONTAINER_CLASS = 'e-wrapper-container';
/** @private */
export var APPOINTMENT_CONTAINER_CLASS = 'e-appointment-container';
/** @private */
export var APPOINTMENT_CLASS = 'e-appointment';
/** @private */
export var BLOCK_APPOINTMENT_CLASS = 'e-block-appointment';
/** @private */
export var BLOCK_INDICATOR_CLASS = 'e-block-indicator';
/** @private */
export var APPOINTMENT_BORDER = 'e-appointment-border';
/** @private */
export var APPOINTMENT_DETAILS = 'e-appointment-details';
/** @private */
export var SUBJECT_WRAP = 'e-subject-wrap';
/** @private */
export var RESOURCE_NAME = 'e-resource-name';
/** @private */
export var APPOINTMENT_TIME = 'e-time';
/** @private */
export var TABLE_WRAP_CLASS = 'e-table-wrap';
/** @private */
export var OUTER_TABLE_CLASS = 'e-outer-table';
/** @private */
export var CONTENT_WRAP_CLASS = 'e-content-wrap';
/** @private */
export var VIRTUAL_TRACK_CLASS = 'e-virtual-track';
/** @private */
export var AGENDA_CELLS_CLASS = 'e-agenda-cells';
/** @private */
export var AGENDA_CURRENT_DAY_CLASS = 'e-current-day';
/** @private */
export var AGENDA_SELECTED_CELL = 'e-active-appointment-agenda';
/** @private */
export var MONTH_HEADER_CLASS = 'e-month-header';
/** @private */
export var AGENDA_HEADER_CLASS = 'e-day-date-header';
/** @private */
export var AGENDA_RESOURCE_CLASS = 'e-resource-column';
/** @private */
export var AGENDA_DATE_CLASS = 'e-date-column';
/** @private */
export var NAVIGATE_CLASS = 'e-navigate';
/** @private */
export var DATE_HEADER_CLASS = 'e-date-header';
/** @private */
export var AGENDA_DAY_BORDER_CLASS = 'e-day-border';
/** @private */
export var DATE_BORDER_CLASS = 'e-date-border';
/** @private */
export var AGENDA_DAY_PADDING_CLASS = 'e-day-padding';
/** @private */
export var DATE_TIME_CLASS = 'e-date-time';
/** @private */
export var DATE_TIME_WRAPPER_CLASS = 'e-date-time-wrapper';
/** @private */
export var AGENDA_EMPTY_EVENT_CLASS = 'e-empty-event';
/** @private */
export var AGENDA_NO_EVENT_CLASS = 'e-no-event';
/** @private */
export var APPOINTMENT_INDICATOR_CLASS = 'e-appointment-indicator';
/** @private */
export var EVENT_INDICATOR_CLASS = 'e-indicator';
/** @private */
export var EVENT_ICON_UP_CLASS = 'e-up-icon';
/** @private */
export var EVENT_ICON_DOWN_CLASS = 'e-down-icon';
/** @private */
export var EVENT_ICON_LEFT_CLASS = 'e-left-icon';
/** @private */
export var EVENT_ICON_RIGHT_CLASS = 'e-right-icon';
/** @private */
export var EVENT_ACTION_CLASS = 'e-event-action';
/** @private */
export var NEW_EVENT_CLASS = 'e-new-event';
/** @private */
export var CLONE_ELEMENT_CLASS = 'e-schedule-event-clone';
/** @private */
export var MONTH_CLONE_ELEMENT_CLASS = 'e-month-event';
/** @private */
export var CLONE_TIME_INDICATOR_CLASS = 'e-clone-time-indicator';
/** @private */
export var DRAG_CLONE_CLASS = 'e-drag-clone';
/** @private */
export var EVENT_RESIZE_CLASS = 'e-event-resize';
/** @private */
export var RESIZE_CLONE_CLASS = 'e-resize-clone';
/** @private */
export var LEFT_RESIZE_HANDLER = 'e-left-handler';
/** @private */
export var RIGHT_RESIZE_HANDLER = 'e-right-handler';
/** @private */
export var TOP_RESIZE_HANDLER = 'e-top-handler';
/** @private */
export var BOTTOM_RESIZE_HANDLER = 'e-bottom-handler';
/** @private */
export var EVENT_RECURRENCE_ICON_CLASS = 'e-recurrence-icon';
/** @private */
export var EVENT_RECURRENCE_EDIT_ICON_CLASS = 'e-recurrence-edit-icon';
/** @private */
export var HEADER_ROW_CLASS = 'e-header-row';
/** @private */
export var ALLDAY_APPOINTMENT_WRAPPER_CLASS = 'e-all-day-appointment-wrapper';
/** @private */
export var ALLDAY_APPOINTMENT_CLASS = 'e-all-day-appointment';
/** @private */
export var EVENT_COUNT_CLASS = 'e-appointment-hide';
/** @private */
export var ROW_COUNT_WRAPPER_CLASS = 'e-row-count-wrapper';
/** @private */
export var ALLDAY_APPOINTMENT_SECTION_CLASS = 'e-all-day-appointment-section';
/** @private */
export var APPOINTMENT_ROW_EXPAND_CLASS = 'e-appointment-expand';
/** @private */
export var APPOINTMENT_ROW_COLLAPSE_CLASS = 'e-appointment-collapse';
/** @private */
export var MORE_INDICATOR_CLASS = 'e-more-indicator';
/** @private */
export var CELL_POPUP_CLASS = 'e-cell-popup';
/** @private */
export var EVENT_POPUP_CLASS = 'e-event-popup';
/** @private */
export var MULTIPLE_EVENT_POPUP_CLASS = 'e-multiple-event-popup';
/** @private */
export var POPUP_HEADER_CLASS = 'e-popup-header';
/** @private */
export var POPUP_HEADER_ICON_WRAPPER = 'e-header-icon-wrapper';
/** @private */
export var POPUP_CONTENT_CLASS = 'e-popup-content';
/** @private */
export var POPUP_FOOTER_CLASS = 'e-popup-footer';
/** @private */
export var DATE_TIME_DETAILS_CLASS = 'e-date-time-details';
/** @private */
export var RECURRENCE_SUMMARY_CLASS = 'e-recurrence-summary';
/** @private */
export var QUICK_POPUP_EVENT_DETAILS_CLASS = 'e-event-details';
/** @private */
export var EVENT_CREATE_CLASS = 'e-event-create';
/** @private */
export var EDIT_EVENT_CLASS = 'e-event-edit';
/** @private */
export var DELETE_EVENT_CLASS = 'e-event-delete';
/** @private */
export var TEXT_ELLIPSIS = 'e-text-ellipsis';
/** @private */
export var MORE_POPUP_WRAPPER_CLASS = 'e-more-popup-wrapper';
/** @private */
export var MORE_EVENT_POPUP_CLASS = 'e-more-event-popup';
/** @private */
export var MORE_EVENT_HEADER_CLASS = 'e-more-event-header';
/** @private */
export var MORE_EVENT_DATE_HEADER_CLASS = 'e-more-event-date-header';
/** @private */
export var MORE_EVENT_HEADER_DAY_CLASS = 'e-header-day';
/** @private */
export var MORE_EVENT_HEADER_DATE_CLASS = 'e-header-date';
/** @private */
export var MORE_EVENT_CLOSE_CLASS = 'e-more-event-close';
/** @private */
export var MORE_EVENT_CONTENT_CLASS = 'e-more-event-content';
/** @private */
export var MORE_EVENT_WRAPPER_CLASS = 'e-more-appointment-wrapper';
/** @private */
export var QUICK_DIALOG_CLASS = 'e-quick-dialog';
/** @private */
export var QUICK_DIALOG_OCCURRENCE_CLASS = 'e-quick-dialog-occurrence-event';
/** @private */
export var QUICK_DIALOG_SERIES_CLASS = 'e-quick-dialog-series-event';
/** @private */
export var QUICK_DIALOG_FOLLOWING_EVENTS_CLASS = 'e-quick-dialog-following-events';
/** @private */
export var FOLLOWING_EVENTS_DIALOG = 'e-following-events-dialog';
/** @private */
export var QUICK_DIALOG_DELETE_CLASS = 'e-quick-dialog-delete';
/** @private */
export var QUICK_DIALOG_CANCEL_CLASS = 'e-quick-dialog-cancel';
/** @private */
export var QUICK_DIALOG_ALERT_OK = 'e-quick-alertok';
/** @private */
export var QUICK_DIALOG_ALERT_CANCEL = 'e-quick-alertcancel';
/** @private */
export var QUICK_DIALOG_ALERT_FOLLOWING = 'e-quick-alertfollowing';
/** @private */
export var QUICK_DIALOG_ALERT_BTN_CLASS = 'e-quick-dialog-alert-btn';
/** @private */
export var EVENT_WINDOW_DIALOG_CLASS = 'e-schedule-dialog';
/** @private */
export var FORM_CONTAINER_CLASS = 'e-form-container';
/** @private */
export var FORM_CLASS = 'e-schedule-form';
/** @private */
export var EVENT_WINDOW_ALLDAY_TZ_DIV_CLASS = 'e-all-day-time-zone-row';
/** @private */
export var EVENT_WINDOW_ALL_DAY_CLASS = 'e-all-day';
/** @private */
export var TIME_ZONE_CLASS = 'e-time-zone';
/** @private */
export var TIME_ZONE_ICON_CLASS = 'e-time-zone-icon';
/** @private */
export var TIME_ZONE_DETAILS_CLASS = 'e-time-zone-details';
/** @private */
export var EVENT_WINDOW_REPEAT_DIV_CLASS = 'e-repeat-parent-row';
/** @private */
export var EVENT_WINDOW_REPEAT_CLASS = 'e-repeat';
/** @private */
export var EVENT_WINDOW_TITLE_LOCATION_DIV_CLASS = 'e-title-location-row';
/** @private */
export var SUBJECT_CLASS = 'e-subject';
/** @private */
export var LOCATION_CLASS = 'e-location';
/** @private */
export var LOCATION_ICON_CLASS = 'e-location-icon';
/** @private */
export var LOCATION_DETAILS_CLASS = 'e-location-details';
/** @private */
export var EVENT_WINDOW_START_END_DIV_CLASS = 'e-start-end-row';
/** @private */
export var EVENT_WINDOW_START_CLASS = 'e-start';
/** @private */
export var EVENT_WINDOW_END_CLASS = 'e-end';
/** @private */
export var EVENT_WINDOW_RESOURCES_DIV_CLASS = 'e-resources-row';
/** @private */
export var DESCRIPTION_CLASS = 'e-description';
/** @private */
export var DESCRIPTION_ICON_CLASS = 'e-description-icon';
/** @private */
export var DESCRIPTION_DETAILS_CLASS = 'e-description-details';
/** @private */
export var EVENT_WINDOW_TIME_ZONE_DIV_CLASS = 'e-time-zone-row';
/** @private */
export var EVENT_WINDOW_START_TZ_CLASS = 'e-start-time-zone';
/** @private */
export var EVENT_WINDOW_END_TZ_CLASS = 'e-end-time-zone';
/** @private */
export var EVENT_WINDOW_BACK_ICON_CLASS = 'e-back-icon';
/** @private */
export var EVENT_WINDOW_SAVE_ICON_CLASS = 'e-save-icon';
/** @private */
export var EVENT_WINDOW_CANCEL_BUTTON_CLASS = 'e-event-cancel';
/** @private */
export var EVENT_WINDOW_SAVE_BUTTON_CLASS = 'e-event-save';
/** @private */
export var EVENT_WINDOW_DIALOG_PARENT_CLASS = 'e-dialog-parent';
/** @private */
export var EVENT_WINDOW_TITLE_TEXT_CLASS = 'e-title-text';
/** @private */
export var EVENT_WINDOW_ICON_DISABLE_CLASS = 'e-icon-disable';
/** @private */
export var EDIT_CLASS = 'e-edit';
/** @private */
export var EDIT_ICON_CLASS = 'e-edit-icon';
/** @private */
export var DELETE_CLASS = 'e-delete';
/** @private */
export var DELETE_ICON_CLASS = 'e-delete-icon';
/** @private */
export var CLOSE_CLASS = 'e-close';
/** @private */
export var CLOSE_ICON_CLASS = 'e-close-icon';
/** @private */
export var ERROR_VALIDATION_CLASS = 'e-schedule-error';
/** @private */
export var EVENT_TOOLTIP_ROOT_CLASS = 'e-schedule-event-tooltip';
/** @private */
export var ALLDAY_ROW_ANIMATE_CLASS = 'e-animate';
/** @private */
export var TIMESCALE_DISABLE = 'e-timescale-disable';
/** @private */
export var DISABLE_DATE = 'e-disable-date';
/** @private */
export var HIDDEN_CLASS = 'e-hidden';
/** @private */
export var DISABLE_DATES = 'e-disable-dates';
/** @private */
export var POPUP_WRAPPER_CLASS = 'e-quick-popup-wrapper';
/** @private */
export var POPUP_TABLE_CLASS = 'e-popup-table';
/** @private */
export var RESOURCE_MENU = 'e-resource-menu';
/** @private */
export var RESOURCE_MENU_ICON = 'e-icon-menu';
/** @private */
export var RESOURCE_LEVEL_TITLE = 'e-resource-level-title';
/** @private */
export var RESOURCE_TREE = 'e-resource-tree';
/** @private */
export var RESOURCE_TREE_POPUP_OVERLAY = 'e-resource-tree-popup-overlay';
/** @private */
export var RESOURCE_TREE_POPUP = 'e-resource-tree-popup';
/** @private */
export var RESOURCE_CLASS = 'e-resource';
/** @private */
export var RESOURCE_ICON_CLASS = 'e-resource-icon';
/** @private */
export var RESOURCE_DETAILS_CLASS = 'e-resource-details';
/** @private */
export var DATE_TIME_ICON_CLASS = 'e-date-time-icon';
/** @private */
export var VIRTUAL_SCROLL_CLASS = 'e-virtual-scroll';
/** @private */
export var ICON_DISABLE_CLASS = 'e-icon-disable';
/** @private */
export var AUTO_HEIGHT = 'e-auto-height';
/** @private */
export var IGNORE_WHITESPACE = 'e-ignore-whitespace';
/** @private */
export var EVENT_TEMPLATE = 'e-template';
/** @private */
export var READ_ONLY = 'e-read-only';
/** @private */
export var MONTH_HEADER_WRAPPER = 'e-month-header-wrapper';
/** @private */
export var INLINE_SUBJECT_CLASS = 'e-inline-subject';
/** @private */
export var INLINE_APPOINTMENT_CLASS = 'e-inline-appointment';
/** @hidden */
export var SCROLL_HIDDEN = 'e-scroll-hidden';
/** @private */
export var ALLDAY_APPOINTMENT_SCROLL = 'e-all-day-scroll';
/** @private */
export var ALLDAY_APPOINTMENT_AUTO = 'e-all-day-auto';
